import axios from "axios"
import moment from "moment"
import { getLevel, getOwnerType } from "./utils"

export async function getCustomFieldValue(rules, settings, owners, rawValue, debug = false) {
	// if (debug) debugger

	if (!Array.isArray(rules)) return rawValue

	const chars = {
		dot: ".",
		space: " ",
		dash: "-",
		slash: "/",
		comma: ","
	}

	const getOwnerId = level => Object.keys(owners).find(key => owners[key].includes(level))

	let value = ""

	for (const rule of rules) {
		if (!(value !== "Syntax Error" && Array.isArray(rule) && rule.length)) continue

		switch (rule[0]) {
			case "val":
				value += rawValue
				break

			case "settings":
				value += settings[rule[1]]
				break

			case "variables":
				const level = getLevel(rule[1])

				const payload = {
					custom_field: rule[2],
					owner_id: getOwnerId(level),
					owner_type: getOwnerType(level)
				}

				const result = await axios
					.post(`${process.env.VUE_APP_API_URL}/api/customfieldvalues/getValue`, payload, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(async ({ data: { customField, customFieldValue } }) => {
						var rules = customField.rules ? JSON.parse(customField.rules) : null
						var computed_bool = customField.rules ? JSON.parse(customField.rules).computed_bool : null

						if (customFieldValue && computed_bool) {
							return await getCustomFieldValue(
								rules ? rules.computed_rules : undefined,
								settings,
								owners,
								customFieldValue.value
							).then(val => val)
						} else if (customFieldValue.value) {
							return customFieldValue.value
						}

						return `\`${customField.name}\``
					})
					.catch(() => "UNDEFINED")

				value += result
				break

			case "char":
				value += chars[rule[1]]
				break

			case "func":
				if (rule[1] == "current_date") value += moment().format(rule[2])
				if (rule[1] == "upper_case") value = value.toUpperCase()
				break

			default:
				value = "Syntax Error"
		}
	}

	return value
}
